<template>
	<v-dialog :persistent="true" max-width="700" v-model="show">
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex md6 xs12>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="companyValidation.name"
											:label="'* '+$t('fields.name')"
											v-model="company.name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="companyValidation.address"
											:label="'* '+$t('fields.address')"
											v-model="company.address"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="companyValidation.city"
											:label="'* '+$t('fields.city')"
											v-model="company.city"></InputField>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:data="'countries'" :error="companyValidation.country_id"
									:label="'* '+$t('fields.country')"
									v-model="company.country_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
								<InputField :error="companyValidation.oib"
											:label="$t('fields.oibVat')"
											v-model="company.oib"></InputField>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.active')"
									v-model="company.active"></CheckBox>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex md6 xs12>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="companyValidation.phone"
											:label="$t('fields.phone')"
											v-model="company.phone"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField :error="companyValidation.email"
											:label="$t('fields.email')"
											v-model="company.email"></InputField>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:data="'subject-types'"
									:error="companyValidation.subject_type_id"
									:label="'* '+$t('fields.type')"
									v-model="company.subject_type_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
												<TextArea
													:error="companyValidation.notes"
													:label="$t('fields.notes')"
													v-model="company.notes"/>
							</v-flex>
							<v-flex xs12>
								<UploadMultiple :label="$t('fields.documents')"
												v-model="company.documents"/>
							</v-flex>
							<v-flex v-if="company.id != 0" xs12>
								<DatePicker :dateLabel="$t('fields.dateAdded')" :readonly="true"
											v-model="company.date_added_display"/>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="closeModal">{{ $t('buttons.cancel') }}</v-btn>
				<v-btn @click="saveClick">{{ $t('buttons.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import InputField from "../trinkets/InputField";
	import DatePicker from "../trinkets/DatePicker";
	import CurrencyField from "../trinkets/CurrencyField";
	import Dropdown from "../trinkets/Dropdown";
	import TextArea from "../trinkets/TextArea";
	import UploadMultiple from "../trinkets/UploadMultiple";
	import CheckBox from "../trinkets/CheckBox";

	export default {
		name: "CompanyModal",
		props: ['show', 'id'],
		components: {
			DatePicker,
			CurrencyField,
			InputField,
			Dropdown,
			TextArea,
			UploadMultiple,
			CheckBox
		},
		data: function () {
			return {
				company: {
					id: this.$route.params.id,
					name: '',
					address: '',
					city: '',
					country_id: null,
					phone: '',
					email: '',
					oib: '',
					subject_type_id: null,
					notes: '',
					documents: [],
					active: true,
					date_added: null
				},
				companyValidation: {
					id: '',
					name: '',
					address: '',
					city: '',
					country_id: '',
					phone: '',
					email: '',
					oib: '',
					subject_type_id: '',
					notes: '',
					documents: '',
					active: '',
					date_added: ''
				},
			}
		},
		watch: {
			show: function () {
				this.resetData();
			},
		},
		methods: {
			resetData() {
				let moment = require('moment');
				this.company = {
					id: 0,
					first_name: '',
					last_name: '',
					address: '',
					city: '',
					country_id: null,
					phone: '',
					email: '',
					oib: '',
					subject_type_id: null,
					notes: '',
					documents: [],
					active: true,
					date_added: null
				};
				this.companyValidation = {
					id: '',
					first_name: '',
					last_name: '',
					address: '',
					city: '',
					country_id: '',
					phone: '',
					email: '',
					oib: '',
					subject_type_id: '',
					notes: '',
					documents: '',
					active: '',
					date_added: ''
				}
			},
			closeModal() {
				this.resetData();
				this.$emit('callback');
			},
			saveClick() {
				let success = true;

				if (this.company.name == '') {
					success = false;
					this.companyValidation.name = this.$t('alerts.fieldError');
				} else {
					this.companyValidation.name = '';
				}
				if (this.company.address == '') {
					success = false;
					this.companyValidation.address = this.$t('alerts.fieldError');
				} else {
					this.companyValidation.address = '';
				}
				if (this.company.city == '') {
					success = false;
					this.companyValidation.city = this.$t('alerts.fieldError');
				} else {
					this.companyValidation.city = '';
				}
				if (this.company.country_id == null) {
					success = false;
					this.companyValidation.country_id = this.$t('alerts.fieldError');
				} else {
					this.companyValidation.country_id = '';
				}
				if (this.company.subject_type_id == null) {
					success = false;
					this.companyValidation.subject_type_id = this.$t('alerts.fieldError');
				} else {
					this.companyValidation.subject_type_id = '';
				}
				if ((this.company.oib != '') && (this.company.country_id == 53)) {
					if (!(this.$checkOIB(this.company.oib))) {
						success = false;
						this.companyValidation.oib = this.$t('alerts.oibError');
					} else {
						this.companyValidation.oib = '';
					}
				} else {
					this.companyValidation.oib = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.company.id != 0) {
						action = 'put';
						addition = '/' + vm.company.id;
					}
					vm.$APICall(action, 'companies' + addition, vm.company, (data, success) => {
						if (success) {
							if (vm.company.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.$emit('callback');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {

		}
	}
</script>

<style scoped>

</style>
